import { useState, useEffect } from 'react';

/**
 * 延遲設定元件的顯示/隱藏狀態

 * 預設延遲時間長度：300 毫秒（antd 元件動畫皆為 300 毫秒）

 * 範例：
 * ```tsx
 * {!!VisibleDelayed(visible) && (
 *   <TableListModal
 *     {...props}
 *     {...{
 *       visible,
 *       ...(props.hasOwnProperty('set_action_id') ? {} : { set_action_id }),
 *       ...(props.hasOwnProperty('action_id') ? {} : { action_id })
 *       // caption
 *     }}
 *   />
 * )}
 * ```
 */
export default function VisibleDelayed(visible: 1 | undefined, delay?: number) {
  const [visible_delayed, set_visible_delayed]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();
  const [visible_processing, set_visible_processing]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();

  useEffect((): void => {
    visible !== visible_processing && set_visible_processing(visible);
  }, [visible, visible_processing, set_visible_processing]);

  useEffect((): void => {
    visible_processing
      ? set_visible_delayed(1)
      : setTimeout(() => {
          set_visible_delayed(undefined);
        }, delay ?? 300);
  }, [visible_processing, delay]);

  return visible_delayed;
}
